import { useQuery } from "@tanstack/react-query";

import { getCloudFrontCookies } from "@lib/api/mediaApi";
import { useAuthenticatedSession } from "@lib/authentication";
import { authenticationQueryKey } from "@lib/authentication/queries/authentication-query-keys";

export const useGetCloudFrontCookies = () => {
  const { getAccessToken } = useAuthenticatedSession();

  const { data, isLoading, isError, isFetching, refetch } = useQuery({
    queryKey: authenticationQueryKey.cloudFrontAuth(),
    queryFn: async () => getCloudFrontCookies(await getAccessToken()),
  });

  return { data, isLoading, isError, isFetching, refetch };
};
